import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { Radio, SpacerRow } from '@zg-rentals/multibrand-ui';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import './index.scss';

type Props = {
  onCancel: () => void;
  onNextFromSelectorPage: (selectedOption: string) => void;
};

const SelectorPage: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  const [selectedOption, setSelectedOption] = React.useState<string>('');

  const onNext = () => {
    props.onNextFromSelectorPage(selectedOption);
  };

  return (
    <>
      <Row>
        <Col>
          <Text type="h3">What is the payment request for?</Text>
        </Col>
      </Row>
      <Row>
        <Col className={`selectorBorder paxl ${selectedOption === 'One-time payment' ? 'highlightedBorder' : ''}`}>
          <Radio
            label={
              <>
                <Text emphasize type="h4">
                  One-time payment
                </Text>
                <Text>Utilities, late fees, or any other one-time property expenses.</Text>
              </>
            }
            labelTextType="body"
            onChange={() => setSelectedOption('One-time payment')}
            checked={selectedOption === 'One-time payment'}
          />
        </Col>

        <SpacerRow size="md" />

        <Col className={`selectorBorder paxl ${selectedOption === 'Payment Plan' ? 'highlightedBorder' : ''}`}>
          <Radio
            label={
              <>
                <Text emphasize type="h4">
                  Payment plan
                </Text>
                <Text>Allow tenant to pay back missed rent in flexible installments.</Text>
              </>
            }
            labelTextType="body"
            onChange={() => setSelectedOption('Payment Plan')}
            checked={selectedOption === 'Payment Plan'}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="primary" full disabled={!selectedOption} onClick={onNext}>
            Next
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="tertiary" full onClick={props.onCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default SelectorPage;
